import React from "react";
import { FiBell, FiAlertCircle, FiClock, FiTrash2, FiStar } from "react-icons/fi";
import { formatDistanceToNow } from "date-fns";

export default function NoticeCard({ notice, onDelete, canDelete }) {
  const date = notice.createdAt ? formatDistanceToNow(new Date(notice.createdAt), { addSuffix: true }) : "";
  const priorityColors = {
    high: { bg: "#fef2f2", border: "#fca5a5", icon: <FiAlertCircle />, color: "#dc2626" },
    normal: { bg: "#f0f9ff", border: "#bae6fd", icon: <FiBell />, color: "#0284c7" },
  };
  const pc = priorityColors[notice.priority] || priorityColors.normal;

  return (
    <div style={{
      background: "#fff",
      borderRadius: "var(--r8)",
      border: `1px solid ${pc.border}`,
      borderLeft: `4px solid ${pc.color}`,
      padding: "16px 20px",
      transition: "var(--t)",
      position: "relative"
    }}>
      {notice.pinned && (
        <div style={{
          position: "absolute", top: 12, right: 12,
          color: "var(--amber-600)", fontSize: "0.85rem"
        }}>
          <FiStar fill="currentColor" size={14} />
        </div>
      )}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
        <div style={{
          width: 36, height: 36, borderRadius: "10px",
          background: pc.bg, color: pc.color,
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0, fontSize: "1rem"
        }}>
          {pc.icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <h4 style={{ fontSize: "0.92rem", fontWeight: 600, color: "var(--gray-900)" }}>
              {notice.title}
            </h4>
            {notice.pinned && (
              <span className="badge badge-warning" style={{ fontSize: "0.68rem" }}>Pinned</span>
            )}
            <span className={`badge ${notice.priority === "high" ? "badge-danger" : "badge-info"}`} style={{ fontSize: "0.68rem" }}>
              {notice.priority === "high" ? "Important" : "General"}
            </span>
          </div>
          <p style={{ fontSize: "0.84rem", color: "var(--gray-700)", marginTop: 6, lineHeight: 1.6 }}>
            {notice.content}
          </p>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 10, flexWrap: "wrap", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: "0.75rem", color: "var(--gray-500)", display: "flex", alignItems: "center", gap: 4 }}>
                <FiClock size={11} /> {date}
              </span>
              <span style={{ fontSize: "0.75rem", color: "var(--gray-500)" }}>
                By: <strong>{notice.author}</strong>
              </span>
              <span className="badge badge-secondary" style={{ fontSize: "0.68rem" }}>
                {notice.audience === "all" ? "Everyone" : notice.audience}
              </span>
            </div>
            {canDelete && (
              <button onClick={() => onDelete(notice.id)} style={{
                background: "none", border: "none", cursor: "pointer",
                color: "var(--gray-500)", padding: 4, borderRadius: 6,
                display: "flex", alignItems: "center"
              }}
              onMouseEnter={e => e.currentTarget.style.color = "var(--red-600)"}
              onMouseLeave={e => e.currentTarget.style.color = "var(--gray-500)"}
              >
                <FiTrash2 size={14} />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
